<template>
    <span>
      <el-date-picker
        v-model="valueDate"
        type="dates"
        :editable="false"
        placeholder="选择日期"
        @change="selectDates"
        :picker-options="pickerOptions">
      </el-date-picker>
      <span v-html="msg"></span>
    </span>
</template>

<script>
import axios from 'axios'
axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost:3002/'

var vaildDates = []
var noShowDates = []
export default {
  name: 'HelloWorld',
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          let dateStr = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
          // console.log(dateStr)
          // return false
          return (vaildDates.indexOf(dateStr) === -1)
        },
        cellClassName (time) {
          let dateStr = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
          if (noShowDates.indexOf(dateStr) === -1) {
            return 'cal-show-dates'
          }
        }
      },
      valueDate: '',
      msg: ''
    }
  },
  created () {
    axios.get('/calInit')
      .then(res => {
        let tempVa = res.data.vaildDate.split(',')
        tempVa.forEach(function (date) {
          if (date !== '') {
            vaildDates.push(date)
          }
        })
        let tempEx = res.data.excludeDate.split(',')
        tempEx.forEach(function (date) {
          if (date !== '') {
            noShowDates.push(date)
          }
        })
        // console.log(vaildDates)
      }).catch(err => {
        console.log(err)
      })
  },
  methods: {
    selectDates: function () {
      let selectDates = []
      this.valueDate.forEach((date) => {
        let dateStr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        selectDates.push(dateStr)
      })
      selectDates = selectDates.join(',')
      // console.log({d: selectDates})
      axios.post('/setExcludeDate', {includeDates: selectDates})
        .then(res => {
          let tempEx = res.data.excludeDate.split(',')
          noShowDates = []
          tempEx.forEach(function (date) {
            if (date !== '') {
              noShowDates.push(date)
            }
          })
          this.valueDate = []
          console.log(noShowDates)
          setTimeout(() => {
            this.msg = '...等待刷新'
          }, 0)
          setTimeout(() => {
            this.msg = '..等待刷新'
          }, 2000)
          setTimeout(() => {
            this.msg = '.等待刷新'
          }, 2250)
          setTimeout(() => {
            this.msg = ''
          }, 2800)
        }).catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style>
.cal-show-dates:not(.disabled) span{
  border: solid red;
  border-radius: 100% 100% 100% 0%;
  border-width:thick thin medium thick;
  border-spacing:1px 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue